var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1603 0H2.83984C1.59212 0 0.589844 1.00227 0.589844 2.25V15.75C0.589844 16.9977 1.61257 18 2.83984 18H9.1603C10.408 18 11.4103 16.9977 11.4103 15.75V2.25C11.4103 1.00227 10.408 0 9.1603 0ZM6.0103 16.5477C5.43757 16.5477 4.98757 16.0977 4.98757 15.525C4.98757 14.9523 5.43757 14.5023 6.0103 14.5023C6.58303 14.5023 7.03303 14.9523 7.03303 15.525C7.03303 16.0977 6.58303 16.5477 6.0103 16.5477ZM10.3876 13.4182H1.61257V3.00682H10.3876V13.4182Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneWhite);
export default __webpack_public_path__ + "static/media/phone-white.ab6226569b67fe84878a6387257800a2.svg";
export { ForwardRef as ReactComponent };